// extracted by mini-css-extract-plugin
export default {"container":"CreateInvite_container__QuYvc"};